import PrivateRoute from '@Components/app-layout/PrivateRoute';
import AppRouter from '@Components/app-layout/Router';

import ForgotFormLayout from './containers/ForgotForm';
import LoginFormLayout from './containers/LoginForm';
import SiteSelectionFormLayout from './containers/SiteSelectionForm';

export default function AuthRoutes() {
  return <AppRouter redirect='/auth/login'>
    <PrivateRoute path="/auth/login" component={LoginFormLayout} />
    <PrivateRoute path="/auth/forgot" component={ForgotFormLayout} />
    <PrivateRoute path="/auth/site_selection" component={SiteSelectionFormLayout} />
  </AppRouter>
}
